<template>
  <div>
    <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <Row>
        <Row>
          <div class="hs-screen-row" v-if="!admin.tenantId">
            <Select v-model="params.tenantId" placeholder="区域商户" clearable style="width:200px">
              <Option v-for="(item, index) in tenantList" :value="item.tenantId" :key="index">{{ item.companyName }}</Option>
            </Select>
          </div>
          <div class="hs-screen-row">
            <DatePicker @on-change="changeDate" type="daterange" :editable="false"
                        separator=" ~ " split-panels transfer placeholder="查询时间"
                        :value="value"
                        style="width: 200px"></DatePicker>
          </div>
          <div class="hs-screen-row">
            <Button type="primary" @click="search">查询</Button>
          </div>
          <div class="hs-screen-row">
            <Button @click="resetScreen">重置</Button>
          </div>
        </Row>

        <Col span="3">
          <Card :bordered="false">
            <div style="text-align:center">
<!--              <h1>{{ orderData.totalNum * 3}}</h1>-->
              <h1>{{ orderData.totalNum}}</h1>
              <span>总订单数量</span>
            </div>
          </Card>
        </Col>
        <Col span="3" offset="1">
          <Card :bordered="false">
            <div style="text-align:center">
<!--              <h1>{{ orderData.totalNum3 * 3 }}</h1>-->
              <h1>{{ orderData.totalNum3 }}</h1>
              <span>已完成数量</span>
            </div>
          </Card>
        </Col>
        <Col span="3" offset="1">
          <Card :bordered="false">
            <div style="text-align:center">
              <h1>{{ orderData.totalNum4 }}</h1>
              <span>已取消数量</span>
            </div>
          </Card>
        </Col>

        <Col span="3" offset="1">
          <Card :bordered="false">
            <div style="text-align:center">
              <h1>￥{{ orderData.totalAmount }}</h1>
              <span>总订单金额</span>
            </div>
          </Card>
        </Col>

        <Col span="3" offset="1">
          <Card :bordered="false">
            <div style="text-align:center">
              <h1>{{ orderData.totalWeight }}KG</h1>
              <span>总订单重量</span>
            </div>
          </Card>
        </Col>
      </Row>
    </Card>

    <Card>
      <div id="charts" name="charts" style="width: 1300px; height: 400px;" ></div>
    </Card>
  </div>
</template>

<script>
import hsBreadcrumb from '@/components/hs-breadcrumb';
import moment from "moment"
import echarts from 'echarts'
export default {
  name: "admin",
  data() {
    let staretime = moment().format('YYYY-MM-DD') + ' 00:00:00';
    let endTime = moment().format('YYYY-MM-DD') + ' 23:59:59';
    return {
      admin: JSON.parse(sessionStorage.getItem('J-ADMIN')) ? JSON.parse(sessionStorage.getItem('J-ADMIN')) : {},
      headers: {
        token: JSON.parse(sessionStorage.getItem('J-TOKEN')).token
      },
      params: {
        startTime: staretime,
        endTime: endTime,
        tenantId: ''
      },
      orderData: {},
      value: [staretime, endTime],
      // 面包屑
      breadcrumb: [
        {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
        {name: '数据统计', url: '', icon: '', size: 0},
        {name: '数据分析', url: '', icon: '', size: 0}
      ],
      lastMonth : [],// 上月时间
      lastData : [],// 上月数据
      sameMonth : [],// 当月时间
      sameData : [],// 当月数据
      tenantList: [],
      recoveryUserList: [],
      completionRate: 0
    }
  },
  created() {
    if (this.$route.query.tenantId) {
      this.admin.tenantId = this.$route.query.tenantId
    }
    this.findTenantAll()
    this.getTotal();
    this.getCharts()
    this.findRecoveryUserList()
    this.getCountCompletionRate()
  },
  mounted() {
    // 缓存执行
    // setTimeout(() => {
    //   this.showCharts()
    // }, 500);

  },
  methods: {
    // 租户查询
    findTenantAll() {
      this.axios.post('/tenant/findAll').then(res => {
        if (res.status == 200) {
          this.tenantList = res.data;
        }
        if (res.status == 201) {
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询区域商户列表接口报错',
            duration: 0
          });
        }
      })
    },
    getTotal() {
      this.axios.post('/recoveryOrder/total', this.params).then(res => {
        this.isTableLoading = false;
        if (res.status == 200) {
          this.orderData = res.data;
          // 数量翻倍-临时使用
          // this.orderData.totalAmount = (this.orderData.totalAmount * 3).toFixed(2);
          // this.orderData.totalWeight = (this.orderData.totalWeight * 3).toFixed(2);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询订单统计接口报错',
            duration: 0
          });
        }
      })
    },
    getCountCompletionRate() {
      this.axios.post('/recoveryOrder/countCompletionRate', this.params).then(res => {
        this.isTableLoading = false;
        if (res.status == 200) {
          this.completionRate = res.data.completionRate;
          // 数量翻倍-临时使用
          // this.orderData.totalAmount = (this.orderData.totalAmount * 3).toFixed(2);
          // this.orderData.totalWeight = (this.orderData.totalWeight * 3).toFixed(2);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询订单统计接口报错',
            duration: 0
          });
        }
      })
    },
    search() {
      this.getTotal();
      this.getCharts();
      this.getCountCompletionRate();
    },
    getCharts() {
      let params = {
        startTime: moment().startOf("month").format("YYYY-MM-DD"),
        endTime: moment().endOf("month").format("YYYY-MM-DD") + ' 23:59:59',
        lastStartTime: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        lastEndTime: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') + ' 23:59:59',
        tenantId: this.params.tenantId
      }
      this.lastMonth = []
      this.lastData = []
      this.sameMonth = []
      this.sameData = []
      this.axios.post('/recoveryOrder/charts', params).then(res => {
        if (res.status == 200) {
          res.data.sameList.forEach(item => {
            this.sameMonth.push(item.monthnum)
            // this.sameData.push(item.num * 3)
            this.sameData.push(item.num)
          });
          res.data.lastList.forEach(item => {
            this.lastMonth.push(item.monthnum)
            // this.lastData.push(item.num * 3)
            this.lastData.push(item.num)
          });
          setTimeout(() => {
            this.showCharts()
          }, 500);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询订单统计接口报错',
            duration: 0
          });
        }
      })
    },
    // 显示图表
    showCharts() {
      let elementById = document.getElementById('charts');
      var myChart = echarts.init(elementById);
      let titleList = ['本月','上月'];

      let option = {
        title: {
          text: '回收单数量对比',
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          // x: 'center',
          // top:'30',
          data:titleList
        },
        xAxis: {
          type: 'category',
          data: this.sameMonth
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: titleList[0],
            data: this.sameData,
            smooth: true,//  true 曲线 false 折线
            type: 'line',
            label: {
              normal: {
                show: true,
                position: 'top'
              }
            },
          },
          {
            name: titleList[1],
            data: this.lastData,
            smooth: true,//  true 曲线 false 折线
            type: 'line',
            label: {
              normal: {
                show: true,
                position: 'top'
              }
            },
          }
        ]
      }
      console.log(option)
      myChart.setOption(option)
    },
    // 日期条件赋值
    changeDate(e) {
      this.params.startTime = e[0] + ' 00:00:00';
      this.params.endTime = e[1] + ' 23:59:59';
    },
    // 重置筛选条件
    resetScreen() {
      let staretime = moment().format('YYYY-MM-DD') + ' 00:00:00';
      let endTime = moment().format('YYYY-MM-DD') + ' 23:59:59';
      this.value = [staretime, endTime];
      this.params.startTime = staretime;
      this.params.endTime = endTime;
      this.getTotal();
    },
     // 回收员-列表查询
     findRecoveryUserList() {
            let params = {
                page: 1,
                rows: 20,
                isDisable: 0,
                tenantId: this.params.tenantId
            }
            this.axios.post('/recoveryUser/findList', params).then(res => {
              if (res.status == 200) {
                if (res.data.rows) {
                  this.recoveryUserList = []
                  res.data.rows.forEach(v => {
                    let object = {
                      value: v.recoveryUserId,
                      label: v.realName
                    }
                    this.recoveryUserList.push(object)
                  })
                }
              }
              if (res.status == 500) {
                this.$Notice.error({
                  title: '服务器内部错误',
                  desc: '查询回收员列表接口报错',
                  duration: 0
                });
              }
            })
          },
  },

  components: {
    hsBreadcrumb,
    echarts
  }
}
</script>

<style scoped lang="less">
</style>
